module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "main_wrap"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('root-header'), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('root-footer')], 1), _vm._v(" "), _c('client-modal'), _vm._v(" "), _c('staff-modal'), _vm._v(" "), _c('details-modal'), _vm._v(" "), _c('edit-modal'), _vm._v(" "), _c('inquiry-modal'), _vm._v(" "), _c('time-modal'), _vm._v(" "), _c('date-picker-modal'), _vm._v(" "), _c('range-picker-modal'), _vm._v(" "), _c('status-modal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b087f34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Root.vue
// module id = 620
// module chunks = 0